<template>
  <div id="app" class="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "../sass/main.scss";

@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');

body {
  height: 100%;

  font-family: 'Montserrat', sans-serif !important;

  #app {
    height: 100%;
  }
}

.va-button
{
  font-family: 'Montserrat', sans-serif !important;
}

.profile-dropdown__anchor
{
  font-family: 'Montserrat', sans-serif;
}

::selection {
  background-color: #222 !important;
}

.profile-dropdown__item:hover,
.profile-dropdown__item:active {
  color: #222 !important;
}

.profile-dropdown__item
{
  color: #222 !important;
}
.row {
  margin-right: 1px !important;
  margin-left: 1px !important;
}

.titlePage {
  color: #F65A6F;
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
  border-style: solid;
  border-color: #F65A6F;
  border-bottom-width: 2px;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.titleList {
  color: #222 !important;
}
.buttonList {
  background-color: #222 !important;

}

.buttonList img {
  -webkit-filter: invert(100%);
    filter: invert(100%);
}

.list-picker-selected {
  background: #222 !important;
}

.loginbtn primaryBtnDetail {
    background-color: #fff !important;
    border-color: #222 !important;
    cursor: pointer;
    border-radius: 5px 5px 5px 5px;
    -moz-border-radius: 5px 5px 5px 5px;
    -webkit-border-radius: 5px 5px 5px 5px;
    width: 80%;
    color: #222 !important;
}

.loginbtn primaryBtnDetail:hover {
  background-color: #fff !important;
  border-color: #222 !important;
}

.profile-dropdown__content{
    background-color: #fff !important;

}

.dg-btn--cancel {
    background-color: #222 !important;
}

.dg-btn--ok {
    color: #222 !important;
    border-color: #222 !important;
}

ol.ollist {
  list-style-type: inherit !important;
  padding-left: 20px;
}
.linkHtml:visited {
    color: #222;
}
.linkHtml:hover {
    color: #222;
}
.linkHtml:active {
    color: #222;
}
</style>
